import * as React from "react";
import { ComponentImage } from '../library/ComponentImage';
import { MainPanel } from '../components/MainPanel';
import { SidePanel } from '../components/SidePanel';

const cx = require('classNames');

export class Panel extends React.Component {
    render() {
        const { type, flipped } = this.props;
        const spriteNames = [
            'top-left', 'top-stretch', 'top-right',
            'bottom-left', 'bottom-stretch', 'bottom-right',
            'left-stretch','right-stretch'
        ];

        const spriteMapping = {};
        spriteNames.forEach((spriteName)=>{
            spriteMapping[spriteName] = spriteName;
        });
        
        if (type === 'SidePanel') {
            spriteNames.unshift('hose');
            spriteMapping['hose'] = 'hose';
        } else {
            spriteMapping['top-right'] = 'top-left';
            spriteMapping['right-stretch'] = 'left-stretch';
            spriteMapping['bottom-right'] = 'bottom-left';
        }
        
        const frame = spriteNames.map((spriteName) => (
            <ComponentImage 
                className={spriteName}
                component={type}
                file={`optimized/${spriteMapping[spriteName]}.png`}
            />
        ));
        
        const content = type === 'SidePanel' ?
            <SidePanel flipped={flipped} />:
            <MainPanel />;

        return (
            <div className={cx({
                'Panel': true,
                'left': flipped,
                'right': !flipped,
                'SidePanel': type === 'SidePanel',
                'MainPanel': type === 'MainPanel',
            })}>
                <div className="glow" />
                <div className="glow" />
                {content}
                <div className="frame">
                    {frame}
                </div>
            </div>
        );
    }
}

Panel.defaultProps = {
    classNames: {}
};



// WEBPACK FOOTER //
// ./react/components/Panel.jsx